module.exports = __webpack_public_path__ + "img/tree-large.201ffe40.svg";